<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
    <ProgramNav :programID="$route.params.programID" />
    <v-row dense>
      <v-col cols="12" xl="12">
        <v-card class="pa-2" outlined tile height="100%">
          <v-data-table
            :headers="headers"
            :items="fireDrills"
            sort-by="Date"
            sort-asc
            :loading="isLoading"
            loading-text="Loading Client's Fire Drills"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Fire Drills</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="75%">
                  <template v-slot:activator="{ on }" v-if="display">
                    <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()">
                      <v-icon left>add</v-icon>
                      Add Fire Drill
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title style="background-color: #2b3990">
                      <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <!-- ... form fields as in GlobalFireDrills ... -->
                        <!-- (omitted for brevity, will be copied in full) -->
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" color="#259647" @click="addFireDrill()" v-if="newFireDrill">Save</v-btn>
                      <v-btn color="blue darken-1" text @click="updateFireDrill()" v-if="editFireDrill">Update</v-btn>
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="mobile ml-5 mr-5 mb-3 mt-3"
              ></v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="goToFireDrillDetail(item)">mdi-eye</v-icon>
              <v-icon small @click="deleteFireDrill(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getFireDrills()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import axios from 'axios';
import Foot from '@/components/Footer';
import ProgramNav from '@/components/ProgramNav';
import moment from 'moment';
const url = require("@/client_config/config").url;

export default {
  components: { Foot, ProgramNav },
  data() {
    return {
      headers: [
        { text: 'Drill Date', align: 'start', sortable: false, value: 'Date' },
        { text: 'Client', value: 'ClientID.Name' },
        { text: 'Staff Signature', value: 'StaffSignature' },
        { text: 'Drill Start Time', value: 'StartTime' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      date: moment(new Date()).format("YYYY-MM-DD"),
      menu: false,
      menu2: false,
      dialog: false,
      editFireDrill: false,
      newFireDrill: false,
      msg: false,
      signed: false,
      search: "",
      text: "",
      fireDrills: [],
      tempData: [],
      codes: [],
      clients: [],
      newClients: [],
      role: localStorage.getItem('userRole'),
      display: false,
      nav: true,
      newStaffSignature: "",
      staff: localStorage.getItem('Name'),
      titleForm: "New Fire Drill",
      fireDrillID: "",
      drillDate: moment(new Date()).format("YYYY-MM-DD"),
      evacuated: "",
      evacuatedExplain: "",
      location: "",
      locationExplain: "",
      closedDoors: "",
      closedDoorsExplain: "",
      obstacles: "",
      obstaclesExplain: "",
      headCount: "",
      headCountExplain: "",
      allParticipation: "",
      allParticipationExplain: "",
      startTime: "",
      duration: "",
      numberOfPeople: "",
      taggedCurrent: "",
      taggedCurrentExplain: "",
      detectorsWorking: "",
      detectorsWorkingExplain: "",
      eachLevel: "",
      eachLevelExplain: "",
      carbonMonoxide: "",
      carbonMonoxideExplain: "",
      carbonEachLevel: "",
      carbonEachLevelExplain: "",
      comments: "",
      newDocument: [],
      uploadFile: "",
      fireDrillForm: "",
      userState: localStorage.getItem('userState'),
      editedIndex: -1,
      editedItem: { /* ... as in GlobalFireDrills ... */ },
      defaultItem: { /* ... as in GlobalFireDrills ... */ },
      isLoading: true,
      clientID: this.$route.params.clientID,
    };
  },
  created() {
    this.getProgramClientsAndFireDrills();
    this.checkRole();
  },
  mounted() {
    this.getProgramClientsAndFireDrills();
  },
  activated() {
    this.getProgramClientsAndFireDrills();
  },
  watch: {
    '$route'() {
      this.getProgramClientsAndFireDrills();
    }
  },
  methods: {
    async getProgramClientsAndFireDrills() {
      this.isLoading = true;
      try {
        // Get program info
        const programID = this.$route.params.programID;
        const programRes = await axios.get(`${url}/units/${programID}`);
        const program = programRes.data.unit;
        if (!program || !program.Name) throw new Error('Program not found');
        // Fetch fire drills for this program directly from backend
        const drillsRes = await axios.get(`${url}/fireDrill/by-program/${encodeURIComponent(program.Name)}`);
        this.fireDrills = drillsRes.data.fireDrills || [];
        // Optionally, set this.clients if you want to use it elsewhere
      } catch (err) {
        this.text = err.response?.data?.msg || err.message;
        this.msg = true;
        this.fireDrills = [];
      } finally {
        this.isLoading = false;
      }
    },
    async goToFireDrillDetail(item) {
      // Use the clientID from the fireDrill item (populated or not)
      const clientID = item.ClientID && item.ClientID._id ? item.ClientID._id : item.ClientID;
      this.$router.push({
            path: `/fireDrill/${clientID}/update/${item._id}`,
            query: { updateFireDrill: true, context: 'program', programID: this.$route.params.programID }
        })
    },
    showAdd() {
      this.$router.push({
          path: `/fireDrill/${this.clientID}/new`,
          query: { createFireDrill: true, context: 'program', programID: this.$route.params.programID}
      })
    },
    deleteFireDrill(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this fire drill?") &&
        this.fireDrillDelete(id);
    },

    fireDrillDelete(id) {
      axios.delete(`${url}/fireDrill/${id}`).then((response) => {
        this.getFireDrills();
        if (response.status === 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The fire drill has been deleted successfully.";
      });
    },
    checkRole() {
      if (
        this.role == "SuperAdministrator" ||
        this.role == "Administration" ||
        this.role == "Program Manager" ||
        this.role == "House Manager" ||
        this.role == "Assistant Manager" ||
        this.role == "Shift Lead" ||
        this.role == "Program Coordinator" ||
        this.role == "Client Services Manager"
      ) {
        this.display = true;
        this.nav = false;
      }
    },
    close() {
      this.dialog = false;
      this.editFireDrill = false;
      this.newFireDrill = false;
      // Optionally reset form fields here if needed
    },
    // ... all other methods from GlobalFireDrills ...
  },
};
</script>

<style scoped>
/* Copy all styles from GlobalFireDrills.vue */
</style> 